import { gatewayService } from "@/common/api.service"
import { gatewayStatus } from "@/constants/gatewayStatus"
import { merchantType } from "@/constants/merchantType"
import {gatewayTypes} from "../../constants/gatewayTypes";

const initialStates = {
    status: 'loading',
    gateways: [],
    starshopGateways: [],
    has_cart_gateway: false,
    payment_helper_shops: {
        status: 'loading',
        data: [],
    },
    reportStatistics: {
        number: 0,
        total_transactions: 0,
        terminal_title: '-',
        last_updated: '-',
    },
    my_statements:{
        total_statements:0,
        total_success_transactions:0,
        today_date: '',
        persian_name:'',
        from_date: '-',
        to_date: '-'
    },
    form_data: {
        farsi_name: '',
        english_name: '',
        subcategory_code: '',
        address: '',
        telephone: '',
        logo: '',
        sheba: [],
        merchant_share_percent: '',
        site_address: '',
        user_server_ip: '',
        callback_address: '',
        can_be_sent_to_shaparak:false,
        show_statement_report_to_user: 0,
        show_full_report_to_user: 0,
        show_psp_report_to_user: 0,
        settlement_to_wallet: false,
        province_code: null,
        city_code: null,
    },
    namadGatewayDetails: {},
    namad_error: '',
    tax_data: {},
    tax_data_status: '',
    legal_gateways: {},
    shop_data_gateway : {
        status: 'loading',
        data: [],
    },
    ivrs: [],
}

const mutations = {
    loading(state) {
        state.status = 'loading'
        state.my_statements.from_date = '-'
        state.my_statements.to_date = '-'
        state.my_statements.persian_name = '-'
        state.my_statements.total_statements = 0
        state.my_statements.total_success_transactions = 0
    },
    success(state, gateways) {
        state.status       = 'success'
        state.gateways = gateways
    },
    starshopSuccess(state, starshopGateways) {
        state.status       = 'success'
        state.starshopGateways = starshopGateways
    },
    fail(state) {
        state.status       = 'fail'
        state.gateways = []
    },
    setFormData(state, form_data) {
        state.status = 'setFormData'
        state.form_data = form_data
    },
    clearFormData(state) {
        state.status = 'clearFormData'
        Object.keys(state.form_data).forEach(function (key){
            if(key == 'sheba') {
                state.form_data[key] = []
            }else {
                state.form_data[key] = ''
            }
        });
    },
    statementsReportStatistics(state,my_statements) {
        state.status = 'successReport'
        state.my_statements = my_statements
    },
    namadGatewayDetails(state, namadGatewayDetails) {
        state.status = 'successNamadDetails'
        state.namadGatewayDetails = namadGatewayDetails
    },
    namad_error(state) {
        state.status = 'namad_error'
    },
    transactionsReportStatistics(state, reportStatistics) {
        state.status = 'successReport'
        state.reportStatistics = reportStatistics
    },
    hasCartGateway(state, has_cart_gateway) {
        state.has_cart_gateway = has_cart_gateway
    },
    setTaxData(state, tax_data) {
        state.tax_data_status = 'setTaxData'
        state.tax_data = tax_data
    },
    loadTaxData(state) {
        state.tax_data_status = 'loading'
    },
    set_payment_helper_shops(state, data) {
        state.payment_helper_shops.data = data;
        state.payment_helper_shops.status = 'success';
    },
    reset_payment_helper_shops(state) {
        state.payment_helper_shops.status = 'loading';
        state.payment_helper_shops.data = [];
    },
    setShopData(state, data) {
        state.shop_data_gateway.data   = data;
        state.shop_data_gateway.status = 'success';
    },
    resetShopData(state) {
        state.shop_data_gateway.status = 'loading';
        state.shop_data_gateway.data   = [];
    },
    setIvrs(state, data) {
        state.ivrs = data
    }
}

const getters = {
    status: ({status}) => status,
    ivrs: ({ivrs}) => ivrs,
    gateways: ({gateways}) => gateways,
    starshopGateways: ({starshopGateways}) => starshopGateways,
    payment_helper_shops: ({payment_helper_shops}) => payment_helper_shops.data,
    payment_helper_shops_status:  ({payment_helper_shops}) => payment_helper_shops.status,
    form_data: ({form_data}) => form_data,
    active_gateways: ({gateways}) => {
        if(gateways.data) {
            return gateways.data.filter(gateway => 
                gateway.status === gatewayStatus.ACTIVE
            )
        }

        return gateways.filter(gateway => 
            gateway.status === gatewayStatus.ACTIVE
        )
    },
    legal_gateways: ({gateways}) => {
        if(gateways.data) {
            return gateways.data.filter(gateway =>
                gateway.merchant_type === merchantType.LEGAL &&
                gateway.status === gatewayStatus.ACTIVE
            )
        }
        return gateways.filter(gateway =>
            gateway.merchant_type === merchantType.LEGAL &&
            gateway.status === gatewayStatus.ACTIVE
        )
    },
    namadGatewayDetails: state =>state.namadGatewayDetails,
    namad_error: state =>state.namad_error,
    reportStatistics: state => state.reportStatistics,
    my_statements:state => state.my_statements,
    hasCartGateway: state => state.has_cart_gateway,
    tax_data_status: state =>state.tax_data_status,
    tax_data: state =>state.tax_data,
    shop_data_gateway: ({shop_data_gateway}) => shop_data_gateway.data,
    shop_data_gateway_status:  ({shop_data_gateway}) => shop_data_gateway.status,
}

const actions = {
    fetch({commit}, is_starshop = false) {
        commit('loading')
        return gatewayService.fetch(is_starshop).then(response => {
        })
    },
    fetchCore({commit}) {
        commit('loading')
        return gatewayService.fetchCore().then(response => {
            commit('success', response.data.data.data)
            commit('hasCartGateway', response.data.data.has_cart_gateway)
            let ivrs = []
            response.data.data.map((item) => {
                if (item.gateway_type === gatewayTypes.IVR)
                    ivrs.push(item)
            })
            commit('setIvrs', ivrs)

        })
    },
    fetchByUserId({commit}, user_id) {
        commit('loading')
        let params = {
            'user_id': user_id
        }
        return gatewayService.fetchCore(params).then(response => {
            commit('success', response.data.data)
        })
    },
    fetchCoreUserGateways({commit}, user_id) {
        commit('loading')
        let params = {
            'user_id': user_id,
            'perpage': 1000,
        }
        return gatewayService.fetchCore(params).then(response => {
            commit('success', response.data.data.data)
        })
    },
    fetchCoreUserGatewaysByAdmin({commit}, user_id) {
        commit('loading')
        let params = {
            'user_id': user_id,
            'perpage': 1000,
        }
        return gatewayService.fetchCoreByAdmin(params).then(response => {
            commit('success', response.data.data.data)
        })
    },
    find({ commit }, { hashid, is_admin, is_starshop = false }) {
        commit('loading');
        return gatewayService.find(hashid, is_admin, is_starshop).then(response => {
            commit('setFormData', response.data.data);
        });
    },
    fetchStarshopUserGatewaysByAdmin({commit}, user_id) {
        commit('loading')
        let params = {
            'user_id': user_id,
            'perpage': 1000,
        }
        return gatewayService.fetchStarshopByAdmin(params).then(response => {
            commit('starshopSuccess', response.data.data.data)
        })
    },
    fetchStarshopUserGateways({commit}, user_id) {
        commit('loading')
        let params = {
            'user_id': user_id,
            'perpage': 1000,
        }
        return gatewayService.fetchStarshop(params).then(response => {
            commit('starshopSuccess', response.data.data.data)
        })
    },
    fetchNamad({commit}, hashid) {
        commit('loading')
        return gatewayService.fetchNamad(hashid).then(
            response => {
                commit('namadGatewayDetails', response.data.data)
            })
            .catch(response => {
            commit('namad_error')
            })
    },


    fetchTaxData({commit}, hashid) {
        commit('loadTaxData')
        return gatewayService.fetchTaxData(hashid).then(response => {
            commit('setTaxData', response.data.data)
        })
    },
    get_payment_helper_shops({commit}) {
        gatewayService.get_payment_helper_shops().then((response) => {
            commit('set_payment_helper_shops', response.data.data);
        });
    },
    fetchReportStatistics({commit}, {hashid, query}) {
        commit('loading')
        return gatewayService.fetchReportStatistics(hashid, query).then(
            response => {
                commit('transactionsReportStatistics', response.data.data)
            })
    },
    fetchReportStatisticsStatements({commit}, params) {
        commit('loading')
        return gatewayService.fetchReportStatisticsStatements(params.hashid, params.query).then(
            response => {
                commit('statementsReportStatistics', response.data.data)
            })
    },
    fetchShopData({commit}) {
        gatewayService.getGatewayUsers().then(response => {
            commit('setShopData', response.data.data);
        })
    },

    fetchTransactionOnlineReport({commit}, {hashid, query}) {
        commit('loading')
        return gatewayService.fetchTransactionOnlineReport(hashid, query).then(
            response => {
                commit('transactionsReportStatistics', response.data.data)
            })
    },
    fetchTransactionOfflineReport({commit}, {hashid, query}) {
        commit('loading')
        return gatewayService.fetchTransactionOfflineReport(hashid, query).then(
            response => {
                commit('statementsReportStatistics', response.data.data)
            })
    },
}


export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}